package com.exura.components.layouts

import androidx.compose.runtime.Composable
import com.exura.components.icons.ExuraLogo
import com.exura.features.newauth.presentation.HandleSession
import com.exura.navigation.Route
import com.exura.primary
import com.exura.surface
import com.exura.ui.Dimens
import com.varabyte.kobweb.compose.css.functions.LinearGradient
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette


@Layout
@Composable
fun NotLoggedInLayout(ctx: PageContext, content: @Composable () -> Unit) {
    val palette = ColorMode.current.toPalette()
    Box(
        modifier = Modifier
            .width(Dimens.appViewWidth)
            .height(Dimens.appViewHeight)
            .backgroundImage(
                linearGradient(
                    palette.primary,
                    palette.primary.darkened(0.65f),
                    LinearGradient.Direction.ToBottom,
                )
            ),
        contentAlignment = Alignment.Center,
    ) {
        Column(
            modifier = Modifier
                .backgroundColor(palette.surface)
                .maxWidth(Dimens.loggingBoxMaxWidth)
                .fillMaxWidth()
                .borderRadius(Dimens.loggingBoxBorderRadius)
                .padding(leftRight = Dimens.loggingBoxIndent, topBottom = Dimens.loggingBoxWrapping),
            verticalArrangement = Arrangement.spacedBy(Dimens.loggingBoxContentGap),
        ) {
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .color(palette.primary),
                contentAlignment = Alignment.Center,
            ) {
                ExuraLogo(modifier = Modifier.height(Dimens.loggingBoxLogoSize))
            }
            content()
        }
    }
}
